import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import permissions from './api';
import apiProxy from './apiProxy';
import application from './application';
import dashboard from './dashboard';
import gatewayBundle from './gatewayBundle';
import organization from './organization';
import portalConfig from './portalConfig';
import proxy from './proxy';
import user from './user';
import eula from './eula';
import userProfile from './userProfile';
import rateQuota from './rateQuota';
import requestSettings from './requestSettings';
import customPages from './customPages';
import request from './request';
import tier from './tier';
import products from './products';
import documentation from './documentation';
import registrationSettings from "./registrationSettings";
import apiKeySettings from './apiKeySettings';
import customFields from './customFields';
import authSchemes from './authSchemes';
import authSettings from './authenticationSettings';
import templateCategory from './templateCategory';
import apiSettings from './apiSettings';
import register from "./register";
import accountSetup from './accountSetup';
import resetPassword from "./resetPassword";
import appearance from "./appearance";
import emailSettings from "./emailSettings";
import settings from "./settings";
import auditLogs from "./auditLogs";
import login from "./login";
import keyStore from "./keyStore";
import newPassword from './newPassword';
import changePassword from './changePassword';
import apiGroups from './apiGroups';
import apiPlans from './apiPlans'
import filterState from './filterState';
import metrics from './metrics';
import authProviders from './authProviders';

const reducers = {
  authProviders,
  permissions,
  application,
  apiKeySettings,
  apiProxy,
  dashboard,
  gatewayBundle,
  organization,
  portalConfig,
  proxy,
  user,
  userProfile,
  eula,
  rateQuota,
  requestSettings,
  customPages,
  request,
  tier,
  products,
  documentation,
  registrationSettings,
  customFields,
  authSchemes,
  authSettings,
  templateCategory,
  apiSettings,
  register,
  accountSetup,
  resetPassword,
  appearance,
  emailSettings,
  settings,
  auditLogs,
  login,
  keyStore,
  newPassword,
  changePassword,
  apiGroups,
  apiPlans,
  filterState,
  metrics,
};
const createRootReducer = (history) =>
  combineReducers(
    history ? { ...reducers, router: connectRouter(history) } : reducers,
  );

export default createRootReducer;
